// extracted by mini-css-extract-plugin
module.exports = {"form":"Checkout_form__oyaYJ","control":"Checkout_control__2MCIY","actions":"Checkout_actions__q6S-N","submit":"Checkout_submit__6bjxy","invalid":"Checkout_invalid__jPm0Z"};